// @file Vuex Store for the app bar account dropdown menu
import { Module } from 'vuex'

interface AppBarAccountState {
  xUserMenu: boolean
}

const initialState = (): AppBarAccountState => {
  return {
    xUserMenu: false,
  }
}

const appBarAccount: Module<AppBarAccountState, object> = {
  namespaced: true,
  state: initialState(),
  getters: {
    xUserMenu: (state): boolean => state.xUserMenu,
  },
  mutations: {
    SHOW_USER_MENU(state): void {
      state.xUserMenu = true
    },
    HIDE_USER_MENU(state): void {
      state.xUserMenu = false
    },
  },
  actions: {
    showUserMenu({ commit }): void {
      commit('SHOW_USER_MENU')
    },
    hideUserMenu({ commit }): void {
      commit('HIDE_USER_MENU')
    },
  },
}

export { AppBarAccountState }
export default appBarAccount
